import { Button } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { CreateTaskDialog } from "./CreateTaskDialog";

export const CreateTaskButton = (props) => {
    const { customerId } = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const handleOpenDialog = useCallback(
        () =>
            openDialog({
                Component: CreateTaskDialog,
                componentProps: {
                    customerId: customerId,
                },
            }),
        [openDialog, customerId],
    );

    return (
        <Button variant="outlined" onClick={handleOpenDialog}>
            {t("tasks.addTask")}
        </Button>
    );
};
